import { FACETS } from '@/constants/facets';
import { Operators } from '@/lib/Configurations';

export const ConstraintValueItemType = {
  INLINE: {
    value: 'group.inline',
    label: 'inline',
  },
  STATIC: {
    value: 'group.static',
    label: 'in GrabX Group',
  },
  SEGP: {
    value: 'group.segp',
    label: 'SegP segment',
  },
};

export const LocationConstraintValueItemType = {
  GRAB_AREA: {
    value: 'grab_area',
    label: 'GrabArea',
  },
};

export const ValueItemTypeSupportedOperator = [
  Operators.in,
  Operators['not in'],
  Operators['='],
  Operators['<>'],
];

export const SegpSupportedFacets = [
  FACETS.Passenger,
  FACETS.Driver,
  FACETS.Merchant,
  FACETS.MexUser,
  FACETS.MexStore,
  FACETS.MexMerchant,
];

export const GeneralLocationFacets = [FACETS.Location];

export const SpecificLocationFacets = [
  FACETS.DropoffLocation,
  FACETS.MerchantLocation,
  FACETS.PickupLocation,
  FACETS.DriverLocation,
];

export const CustomInputFacets = [
  FACETS.AvailibilityZone,
  FACETS.Build,
  FACETS.City,
  FACETS.ClientName,
  FACETS.Country,
  FACETS.DestinationService,
  FACETS.DevelopmentStage,
  FACETS.Device,
  FACETS.DeviceBrand,
  FACETS.DeviceLanguage,
  FACETS.DeviceLocale,
  FACETS.DeviceScreenFactor,
  FACETS.Domain,
  FACETS.EC2InstanceID,
  FACETS.EndpointName,
  FACETS.FoodBusinessType,
  FACETS.FoodOrderType,
  FACETS.MobileCountryCode,
  FACETS.OsType,
  FACETS.OsVersion,
  FACETS.Region,
  FACETS.ScribeSDKVersion,
  FACETS.ServerName,
  FACETS.Timestamp,
  FACETS.TridentTreatmentGroup,
  FACETS.VehicleTypeID,
];
